module.exports = __webpack_public_path__ + "img/vip_icon4@2x.0b41998f.png";